/**
 * api接口调用
 */
import router from '../router/index'
import customLocalStorage from 'store'
import axios from 'axios'
import { isBlank } from './is_blank.js'
// 创建axios实例
// var baseURL = null
console.log(process.env.NODE_ENV)
// baseURL = 'https://3c-canteen-master.deyicy.com'
// baseURL = 'http://m.my3c.com'
// let baseURL = 'http://st0025.deyicy.com'
// let baseURL = 'http://st.deyicy.com'
// http://st.hbzgyc.com
const service = axios.create({
  baseURL: isBlank(customLocalStorage.get('canteenPCHost')) ? (process.env.NODE_ENV === 'development' ? 'http://ts0003.hbzgyc.com' : '') : customLocalStorage.get('canteenPCHost'), // api的base_url
  // baseURL: baseURL,
  headers: { 'content-type': 'application/json' },
  timeout: 0 // 请求超时时间,指定请求超时的毫秒数(0 表示无超时时间)
})

// request拦截器
service.interceptors.request.use(
  config => {
    let token = ''
    if (customLocalStorage.get('canteenPCToken')) {
      token = customLocalStorage.get('canteenPCToken')
    }
    config.headers['Authorization'] = 'Bearer' + ' ' + token
    return config
  },
  error => {
    // 请求错误的时候
    Promise.reject(error)
  })

// respone拦截器
service.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // console.log(error.response)
    if (error.response.status === 401) {
      router.push({
        path: '/login'
      })
    }
    if (error.response.status === 403) {
      if (error.response.data.code === 50001) {
        router.push({
          path: '/'
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js